<h4 data-testid="text">{{ text() }}</h4>
<fa-icon
  [icon]="faXmark"
  (click)="closeModal.emit()"
  data-testid="close-icon"
/>
